import { MultiSelectOption } from "@dune/types";
import { useCallback, useState } from "react";
import { fetchSearchUsers } from "../api/queries/users.queries";

export function useDebouncedUserSearch() {
	const [results, setResults] = useState<MultiSelectOption[]>([]);
	const [isLoading, setIsLoading] = useState(false);

	const search = useCallback(
		async (q: string): Promise<MultiSelectOption[]> => {
			setIsLoading(true);
			try {
				const res = await fetchSearchUsers(q);
				setResults(res);
				return res;
			} catch {
				setResults([]);
				return [];
			} finally {
				setIsLoading(false);
			}
		},
		[],
	);

	return { results, isLoading, search };
}
